import { Component, input, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Asset } from 'app/classes/asset';
import { IIssueEntity, Issue } from 'app/classes/issue';
import { APIService } from 'app/shared/api.service';
import { IssueTrackingService, ITrackingIssue } from 'app/shared/issue-tracking.service';

@Component({
  selector: 'app-setpoint-query-issues',
  standalone: false,
  templateUrl: './setpoint-query-issues.component.html',
  styleUrl: './setpoint-query-issues.component.css'
})
export class SetpointQueryIssuesComponent {

  asset = input.required<Asset>()
  dialog = signal<'new-issue' | 'add-to-issue' | 'confirm-add-to-issue'>(null);

  issue = signal<ITrackingIssue>(null);

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private issueTrackingService: IssueTrackingService, private apiService: APIService) { }

  createIssue() {
    this.router.navigate(['/issuetracking', 'create'], { queryParams: { asset_id: this.asset().id } });
  }

  clickSelectIssueToAdd() {
    this.issue.set(null);
    this.dialog.set('add-to-issue');
  }

  addToIssue(issue: ITrackingIssue) {
    console.log(issue);
    this.issue.set(issue);
    this.dialog.set('confirm-add-to-issue');
  }

  submitToIssue() {
    this.dialog.set(null);
    this.apiService.toastSuccess('Adding asset to issue...', null, 1000);

    const entity: IIssueEntity = { field: 'asset_id', value: this.asset().id, title: this.asset().title };

    this.issueTrackingService.updateEntitiesForIssue(this.issue().id, { add: [entity] }).then(() => {
      this.apiService.toastSuccess('Saved changes.', null, 1000);
    });
  }
}
